import axios from 'axios';

const apiClient = axios.create({
  baseURL: process.env.VUE_APP_API_URL, 
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  }
});

console.log('API Client inicializado com a baseURL:', process.env.VUE_APP_API_URL);

export default apiClient;